// frontend/src/pages/Contacts/NewContactPage.jsx
// Ruta /contacts/new — crear contacto, opcionalmente pré-associado a uma empresa
// (?company=<uuid>). Antes esta URL caía em /contacts/:id com id="new" e o
// backend devolvia 500 (invalid input syntax for type uuid).
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ContactForm from '../../components/Contacts/ContactForm';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const NewContactPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const companyParam = searchParams.get('company') || '';
  const companyId = UUID_RE.test(companyParam) ? companyParam : '';

  const handleClose = () => {
    // Volver a la empresa de origen si venimos de una, si no a la lista.
    navigate(companyId ? `/companies/${companyId}` : '/contacts');
  };

  return (
    <ContactForm
      isOpen
      contact={companyId ? { company_id: companyId } : null}
      onClose={handleClose}
      onSuccess={handleClose}
    />
  );
};

export default NewContactPage;
